import React from 'react';

const ContractTemplatesIcon = ({
  width = '15',
  height = '15',
  stroke = '#222222',
  ...props
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    viewBox="0 0 15 15"
    fill="none"
    {...props}
  >
    <g clipPath="url(#clip0_3643_1485)">
      <path
        d="M13.5738 13.5752H1.42383"
        stroke={stroke}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.13698 2.13927L2.45703 7.32598L8.23499 10.6375L11.0119 4.46966C11.2 4.04186 11.0327 3.54116 10.6252 3.31236L7.91145 1.7504C7.30816 1.40317 6.53977 1.57156 6.13698 2.13927Z"
        stroke={stroke}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.22995 10.6321L2.45716 7.32275L2.9709 10.2699C3.02533 10.5822 2.96815 10.9036 2.80935 11.178L1.42383 13.5718L4.09047 13.575L4.82133 12.3059C4.97286 12.0429 5.20863 11.8385 5.4906 11.7259L8.22995 10.6321Z"
        stroke={stroke}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_3643_1485">
        <rect width="15" height="15" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export default ContractTemplatesIcon;
